import React, { PureComponent } from 'react';
import { Field } from 'redux-form';
import { Image } from '../index';

class Header extends PureComponent {

  render() {
    return (
      <div className="planet-header">
        <div className="form-group planet-header__image">
          <Field
            name="imageUrl"
            component={Image}/>
        </div>

        <div className="row">
          <div className="col-md-3"><label>Title</label></div>
          <div className="col-md-9">
            <div className="form-group">
              <Field
                className="form-control"
                name="title"
                component="input"
                type="text"
                placeholder="Title"/>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-3"><label>Sub Title</label></div>
          <div className="col-md-9">
            <div className="form-group">
              <Field
                className="form-control"
                name="subTitle"
                component="input"
                type="text"
                placeholder="Sub title"/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Header.propTypes = {};
Header.defaultProps = {};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.js